<template>
  <NicePopup no-padding class="sidebar-switcher-wrapper" ref="$switcher" @change="switcherToggle">
    <template #trigger>
      <div class="organization active" :class="{ small: generalStore.sidebarSmall }">
        <NiceAvatar class="icon" :text="generalStore.organization.name" />
        <div class="info" v-if="generalStore.organization && !generalStore.event">
          <div class="subtitle">{{ $gettext("Organization") }}</div>
          <div class="title">{{ generalStore.organization.name }}</div>
        </div>
        <div class="info" v-if="generalStore.organization && generalStore.event">
          <div class="subtitle">{{ generalStore.organization.name }}</div>
          <div class="title">{{ generalStore.event.name }}</div>
        </div>
        <NiceIcon class="chevron" icon="icon-chevron-down" />
      </div>
    </template>

    <template #content>
      <div class="input-group">
        <input v-model="filters.search" type="text" name="Search" placeholder="Search..." @input="searchChanged" />
        <NiceLoading class="loading" v-if="loading" />
      </div>

      <NiceNoData v-if="!items.length && !loading" />

      <div class="items">
        <div class="item" v-for="item in items" :key="item.id">
          <!-- Organization -->
          <div
            class="organization"
            v-if="item.type == 'ORGANIZATION'"
            :class="{ active: !generalStore.event && item.id == generalStore.organizationId }"
            @click="selectItem(item)"
          >
            <!-- <NiceAvatar class="icon" :text="item.name" /> -->
            <div class="info">
              <!-- <div class="subtitle">{{ $gettext("Organization") }}</div> -->
              <div class="title">{{ item.name }}</div>
            </div>
          </div>

          <!-- Event -->
          <div
            class="organization"
            v-if="item.type == 'EVENT'"
            :class="{ active: item.id == (generalStore.event ? generalStore.event.id : null) }"
            @click="selectItem(item)"
          >
            <!-- <NiceAvatar class="icon" :text="item.name" /> -->
            <div class="info">
              <div class="subtitle">{{ item.organization.name }}</div>
              <div class="title">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </NicePopup>
</template>

<script setup>
// import ApiService from "@/services/api/api.service";
import ApiService from "@/services/api/api.service";
import ErrorService from "@/services/error.service";
import StorageService from "@/services/storage.service";
import { useGeneralStore } from "@/store/general.store";
import { ref } from "vue";

import { useRouter } from "vue-router";
const router = useRouter();

let searchDebounce = null;
const generalStore = useGeneralStore();
const loading = ref(false);
const $switcher = ref(false);
const items = ref([]);
const filters = ref({
  search: null,
});

function switcherToggle(isOpen) {
  if (isOpen) getData();
}

function searchChanged() {
  clearTimeout(searchDebounce);
  searchDebounce = setTimeout(() => {
    // generalStore.getData();
    getData();
  }, 500);
}

async function getData() {
  loading.value = true;
  try {
    items.value = await ApiService.internal.find(filters.value.search);
  } catch (e) {
    ErrorService.showError(e);
  } finally {
    loading.value = false;
  }
}

async function selectItem(item) {
  loading.value = true;
  if (item.type == "ORGANIZATION") {
    // Organization
    StorageService.removeOrganization();
    StorageService.removeEvent();
    generalStore.setEvent(null);
    await generalStore.getOrganization(item.id);
    router.push({
      name: "app.organizations.events.all",
      params: { organizationId: item.id },
      query: {},
      force: true,
    });
  } else {
    // Event
    StorageService.removeOrganization();
    StorageService.removeEvent();
    await generalStore.getOrganization(item.organization.id);
    await generalStore.getEvent(item.organization.id, item.id);
    router.push({
      name: "app.organizations.events.dashboard",
      params: { organizationId: item.organization.id, eventId: item.id },
      query: {},
      force: true,
    });
  }
  // setTimeout(() => {
  //   window.location.reload();
  // });
  if ($switcher.value) {
    $switcher.value.close();
  }
}
</script>

<style lang="scss">
.sidebar-switcher-wrapper {
  margin: 0 1rem;
  // border: 1px solid var(--border-color);
  // border-radius: var(--border-radius);

  .nice-popup-content {
    display: flex;
    flex-direction: column;
    max-height: 80vh;

    .input-group {
      flex-shrink: 0;
    }

    .items {
      overflow: auto;
    }
  }
}
</style>

<style scoped lang="scss">
.input-group {
  display: flex;
  align-items: center;
  input {
    flex-grow: 1;
    border: 0 none;
    background: transparent;

    &:focus {
      outline: none;
    }
  }
  .nice-loading {
    padding: 0;
    margin-right: 0.5rem;
    margin-left: 0.7rem;
    height: 18px;
    // width: 18px;
    flex-shrink: 0;
  }
}

.items {
  width: 272px;
  // border: 1px solid var(--border-color);

  .organization {
    // border-bottom: 1px solid var(--border-color);
    margin-bottom: 0;
    border-radius: 0;

    &:last-child {
      border-bottom: 0 none;
    }
  }
}

.nice-no-data {
  padding: 2rem;
  text-align: center;
  opacity: 0.5;
}

.organization {
  padding: 1rem;
  border-radius: var(--border-radius);
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--font-color);
  position: relative;
  cursor: pointer;

  &.small {
    padding: 0;
    justify-content: center;

    .icon {
      margin: 0;
      height: 38px;
      width: 38px;
    }

    .info,
    .chevron {
      display: none;
    }

    &.active {
      background: transparent;
    }
  }

  &.active {
    background: var(--primary-color-bg);
  }

  &:hover {
    color: var(--primary-color);
  }

  .icon {
    flex-shrink: 0;
    height: 35px;
    width: 35px;
    margin-right: 0.8rem;
  }

  .info {
    flex-grow: 1;

    .title {
      font-weight: 600;
    }

    .subtitle {
      font-size: 0.7rem;
      font-weight: 500;
    }
  }

  .chevron {
    position: absolute;
    height: 25px;
    width: 25px;
    top: 50%;
    transform: translateY(-50%);
    right: 1rem;
  }
}
</style>
